export default "__VITE_ASSET__BSmTyTRM__"